import React, { useEffect, useState, useRef } from "react";
import "../App.css";
import Profile from "../Assets/Onboardingimages/Profile.png";
import uploadicon from "../Assets/Onboardingimages/uploadicon.png";
import individual from "../Assets/Onboardingimages/individual.png";
import school from "../Assets/Onboardingimages/school.png";
import thinking from "../Assets/Onboardingimages/thinking.png";
import googleicon from "../Assets/Onboardingimages/googleicon.png";
import coparentprofile from "../Assets/Dashboardimages/coparentprofile.png";
import familymember from "../Assets/Dashboardimages/familymember.png";
import parentprofile from "../Assets/Dashboardimages/parentprofile.png";
import schoolrepresentative from "../Assets/Dashboardimages/schoolrepresentative.png";
import family from "../Assets/Onboardingimages/family.png";
import applelogo from "../Assets/Onboardingimages/applelogo.png";
import actioneditoutline from "../Assets/Onboardingimages/action-edit-outline.png";
import {
  Upload,
  Typography,
  Button,
  Form,
  Input,
  Card,
  Radio,
  message,
  Popover,
  Tag,
  Image,
  Skeleton,
} from "antd";
import {
  UploadOutlined,
  EditOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { URL } from "../helper/Mainurl";

import { Col, Row } from "antd";
import Password from "antd/es/input/Password";
import jwtDecode from "jwt-decode"; // Install it if not already installed
import { useNavigate, useLocation } from "react-router-dom";
import styled from "@emotion/styled";

//stripe
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// images
// quelld-frontend\src\Assets\MyProfile\Family Calendar 1 1.png
import familyCalendar from "../Assets/MyProfile/Family Calendar 1 1.png";
import coParentCalendar from "../Assets/MyProfile/Co Parent Calendar Icon 1.png";
import emailAssistant from "../Assets/MyProfile/email assistant Icon Final 1.png";
import PaymentForm from "../Components/Payments/PaymentForm";
import CancelSubscriptionModal from "../Components/Modals/CancelSubscriptionModal";
import { useSubscriptions } from "../contexts/subscriptionsContext";
import { useUserInfo } from "../contexts/userInfo";

const { Text } = Typography;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 24px;

  @media (max-width: 576px) {
    gap: 12px;
  }
`;

const OptionCard = styled.div`
  border: 2px solid ${({ selected }) => (selected ? "#a855f7" : "#e5e7eb")};
  border-radius: 16px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  transition: 0.3s all;
  background: white;
  position: relative;
  min-height: 100%;

  &:hover {
    border-color: #a855f7;
  }

  img {
    height: 48px;
    margin-bottom: 12px;
  }

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #111827;
  }

  p {
    margin-top: 4px;
    font-size: 14px;
    color: #6b7280;
  }

  .radio {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  .image-container {
    height: 35px; /* enough to handle image + spacing */
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .current-badge {
    position: absolute;
    top: 0px;
    right: 0px;
    background: linear-gradient(90deg, #9a4fe0, #b979ed);
    color: white;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
    border-top-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 14px;
    border-bottom-left-radius: 14px;
    z-index: 1;
    margin: 1px;
  }
  @media (max-width: 768px) {
    text-align: left;
    padding: 12px;
  }
`;

const PriceStyle = styled.div`
  display: flex;
  align-items: baseline;
  font-weight: 700;

  .currency {
    color: #9254de;
    font-size: 20px;
  }

  .amount {
    color: #9254de;
    font-size: 28px;
    margin-left: 2px;
  }

  .per {
    color: #8c8c8c;
    font-size: 16px;
    margin-left: 4px;
  }

  @media (max-width: 576px) {
    .currency {
      font-size: 16px;
    }

    .amount {
      font-size: 22px;
    }

    .per {
      font-size: 14px;
    }
  }
`;

// export const PriceDisplay = ({ amount }) => (
//   <PriceStyle>
//     <span className="currency">£</span>
//     <span className="amount">{amount}</span>
//     <span className="per">/ Mo</span>
//   </PriceStyle>
// );

const getBillingLabel = (billingCycle) => {
  const cycle = billingCycle?.trim()?.toLowerCase();

  switch (cycle) {
    case "monthly":
      return "/ Mo";
    case "quarterly":
      return "/ Qtr";
    case "yearly":
      return "/ Yr";
    case "daily":
      return "/ Day";
    default:
      return "";
  }
};
export const PriceDisplay = ({ price, special_price, billingCycle }) => {
  const billing = getBillingLabel(billingCycle);
  console.log(billingCycle, "billingCycle");

  return (
    <PriceStyle>
      {special_price ? (
        <>
          <span className="currency">£</span>
          <span className="amount">{special_price}</span>
          <span className="per">/ {billing}</span>
          <span style={{ display: "inline-block", width: 8 }} />
          <span className="currency">£</span>
          <span
            className="amount"
            style={{
              color: "#ff4d4f",
              textDecoration: "line-through",
              marginRight: 8,
            }}
          >
            {price}
          </span>
        </>
      ) : (
        <>
          <span className="currency">£</span>
          <span className="amount">{price}</span>
          <span className="per">{billing}</span>
        </>
      )}
    </PriceStyle>
  );
};
const MyProfile = () => {
  const { fetchProfile } = useUserInfo();
  const navigate = useNavigate();
  const { isCoParent } = useSubscriptions();

  const token = localStorage.getItem("authToken"); // Get token from localStorage
  // console.log("token:::", token);
  const stripePromise = loadStripe(
    "pk_test_51ROvWiPNhqoxPYwxdrEdMIt5MRvfupMkXlDuWa4DPMtPOHaZG5stLrDr3mBST8fxNKP7CknTgglLDizcKiTJhuMf00MVVOWqAc"
  ); // your publishable key

  const [form] = Form.useForm();

  const [isUploading, setIsUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState(""); // Default image
  const [selectedRadio, setSelectedRadio] = useState(null); // State for Radio Button
  const [selectCard, setSelectCard] = useState(false);
  const [emailselect, setEmailselect] = useState(false);
  const [updateLodaing, setUpdateLoading] = useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [userCategory, setUserCategory] = useState([]);
  const [emailFlag, setEmailFlag] = useState(null);
  const [emailPreferance, setEmailPreferance] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [visible, setVisible] = useState(false);
  const [newTask, setNewTask] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [categoryMetadata, setCategoryMetadata] = useState([]);
  const [selectedKeyword, setSelectedKeyword] = useState([]);
  const [password, setPassword] = useState(""); // State for password
  const [confirmPassword, setConfirmPassword] = useState(""); // State for confirm password
  const [inputValue, setInputValue] = useState(userDetails.name || "");
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmError, setConfirmError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [removeProfile, setRemoveProfile] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [isEditable, setIsEditable] = useState({
    name: false,
    nickname: false,
    phone_number: false,
  });
  const [profileImage, setProfileImage] = useState("");
  const [subscription, setSubscription] = useState(null); // Store subscription data in state
  const [userId, setUserId] = useState("");
  const [subscriptionLable, setSubscriptionLable] = useState([]);
  const [deletedKeywords, setDeletedKeywords] = useState([]);
  const [subscribeView, setSubscribeView] = useState([]);
  const [phonenumbererror, setPhonenumbererror] = useState({
    phone_number: "",
  });

  // subscription
  const [subscriptionId, setSubscriptionId] = useState("");
  const inputRefs = useRef({});
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [currentStepC2, setCurrentStepC2] = useState(1); // 1 = plan, 2 = payment, 3 = thank you
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [userFeatures, setuserFeatures] = useState(null);
  const [activePlanLoading, setActivePlanLoading] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isModalClosing, setIsModalClosing] = useState(false);

  const fetchSubscriptions = async () => {
    try {
      setActivePlanLoading(true);
      const response = await fetch(`${URL}/v1/user/subscription`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (data.code === 200) {
        // console.log("response_setSubscriptionData",data.data.subscriptions)
        // setSubscriptionData(data.data.subscriptions);
        const subs = data.data.subscriptions;
        setSubscriptionData(subs);

        const activePlan = subs.find((p) => p.is_purchased);
        if (activePlan) setSubscriptionId(activePlan.subscription_id); // ✅ Store subscriptionId properly
      }
      setActivePlanLoading(false);
    } catch (error) {
      setActivePlanLoading(false);
      console.error("Error fetching subscriptions:", error);
    }
  };

  // console.log("Active_plan", subscriptionId);

  const handleInputChangeform = (e, field) => {
    let value = e.target.value;

    if (field === "phone_number") {
      // Remove all non-numeric characters except '+'
      value = value.replace(/[^0-9+]/g, "");

      // UK phone number validation
      const ukPhoneRegex =
        /^(?:(?:\+44)|(?:0))(?:(?:(?:1\d{8,9})|(?:7[1-9]\d{8})|(?:2\d{9})|(?:3\d{9})|(?:5\d{9})|(?:8\d{9})|(?:9\d{9})))$/;

      if (value && !ukPhoneRegex.test(value)) {
        setPhonenumbererror((prev) => ({
          ...prev,
          phone_number: "Please enter a valid phone number",
        }));
      } else {
        setPhonenumbererror((prev) => ({ ...prev, phone_number: "" }));
      }
    }
    setUserDetails({ ...userDetails, [field]: value });
  };

  const handleInputBlur = (field) => {
    if (field == "phone_number") {
      setPhonenumbererror((prev) => ({ ...prev, phone_number: "" }));
    }
  };

  // Toggle edit mode
  const toggleEdit = (field) => {
    setIsEditable({ ...isEditable, [field]: !isEditable[field] });

    // Focus on the input field if it's now editable
    setTimeout(() => {
      if (inputRefs.current[field]) {
        inputRefs.current[field].focus();
      }
    }, 1);
  };
  //
  const passwordPattern =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).{8,}$/;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Validate Password Match
  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    // Check if confirm password matches new password
    if (value !== password) {
      setConfirmError("Passwords do not match!");
    } else {
      setConfirmError("");
    }
  };

  const handleSelect = (keyword) => {
    let allowSelect = true;
    setSelectedKeyword((prev) => {
      const exists = prev.some(
        (item) =>
          (keyword.id && item.id === keyword.id) ||
          (!keyword.id && item.title === keyword.title)
      );

      // Determine if keyword is user-choice or admin
      const isAdminKeyword = Number(keyword.is_added_by_admin) === 1;
      const isUserChoiceKeyword =
        Number(keyword.onboarding_step_keyword) === 1 ||
        (Number(keyword.is_added_by_admin) === 0 &&
          Number(keyword.onboarding_step_keyword) === 0);

      // Count how many user-choice keywords are currently selected
      const selectedUserChoiceCount = prev.filter(
        (item) =>
          Number(item.is_added_by_admin) === 0 &&
          (Number(item.onboarding_step_keyword) === 1 ||
            Number(item.onboarding_step_keyword) === 0)
      ).length;

      if (exists) {
        // Deselect logic
        return prev.filter(
          (item) =>
            (keyword.id && item.id !== keyword.id) ||
            (!keyword.id && item.title !== keyword.title)
        );
      } else {
        // Selection logic
        if (isAdminKeyword) {
          // ✅ Always allow admin keywords
          return [...prev, { ...keyword, is_selected: 1 }];
        }

        if (isUserChoiceKeyword) {
          if (selectedUserChoiceCount >= 3) {
            message.warning(
              "You can select up to 3 custom/onboarding keywords only!"
            );
            allowSelect = false;
            return prev;
          }
          return [...prev, { ...keyword, is_selected: 1 }];
        }
      }

      return prev;
    });

    // Update selection state inside the full list
    if (allowSelect) {
      setEmailPreferance((prevKeywords) =>
        prevKeywords.map((item) =>
          (keyword.id && item.id == keyword.id) ||
          (!keyword.id && item.title === keyword.title)
            ? { ...item, is_selected: item.is_selected === 1 ? 0 : 1 }
            : item
        )
      );
    }
  };

  // console.log(selectedKeyword, "selectedKeyword");

  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 2; // Convert bytes to MB

    if (!isLt2M) {
      message.error("File size must be smaller than 2MB!");
      return Upload.LIST_IGNORE; // Prevent upload
    }

    handleUpload({ file });
    return false; // Stop default upload behavior
  };

  const handleUpload = ({ file }) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageUrl(e.target.result);
      // message.success("Image uploaded successfully!"); // Show success message
      // Store the Base64 string
    };
    reader.readAsDataURL(file); // Convert file to Base64
  };

  const handleRadioChange = (e) => {
    setSelectedRadio(e.target.value);
  };

  const handleClickChange = () => {
    setSelectCard(true);
  };

  const handleEmailsearch = () => {
    setEmailselect(true);
  };

  const getuserData = async () => {
    try {
      const response = await fetch(`${URL}/v1/get-profile`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code === 200 && data.data) {
        setUserId(data.data.user_id);
        setUserDetails(data.data);
        setUserCategory(data.data.user_category);
        setEmailFlag(data.data.parsing_email);
        setEmailPreferance(data.data.email_preferences);
        setProfileImage(data.data.profile_image);
        setSelectedKeyword(
          data?.data?.email_preferences?.filter((key) => key.is_selected === 1)
        );
        // console.log("image::::", data.data.profile_image);
      } else if (data.code === 401 && data.message === "Unauthenticated") {
        localStorage.removeItem("token"); // Clear invalid token (optional)
        navigate("/");
      }
      // console.log("response>>>>>", data);
    } catch (error) {}
  };
  const getemailKeyword = async () => {
    try {
      const response = await fetch(`${URL}/v1/get-keywords`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code == 200) {
        setKeywords(data.data.keywords);
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
    } catch (error) {}
  };
  const getsubscription = async () => {
    try {
      const response = await fetch(`${URL}/v1/user/subscription/${userId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", response.data);
      const data = await response.json();
      if (data.code == 200) {
        // setSubscriptionLable(data.data);
        console.log("labeldata", data.data);
      } else {
        console.error("Invalid response from server:", data); // Log detailed error
        // message.error("Failed to load profile data."); // User-friendly error message
      }
      console.log("response>>>>>", data);
    } catch (error) {}
  };
  const handlemetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/get-onboarding-metadata`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        setCategoryMetadata(data.data.user_category || []);
        // Do something with the data
      } else {
        console.error("Error fetching metadata:", data.message);
      }
    } catch (error) {
      console.error("Fetch request failed:", error);
    }

    // message.error(error.message);
  };

  const handleUpdate = async () => {
    setUpdateLoading(true);
    // UK phone number validation regex
    const ukPhoneRegex =
      /^(?:(?:\+44)|(?:0))(?:(?:(?:1\d{8,9})|(?:7[1-9]\d{8})|(?:2\d{9})|(?:3\d{9})|(?:5\d{9})|(?:8\d{9})|(?:9\d{9})))$/;

    // UK email validation regex
    const ukEmailRegex =
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.(?:co\.uk|ac\.uk|org\.uk|me\.uk|ltd\.uk|plc\.uk|nhs\.uk|[A-Za-z]{2,})$/;

    // Validate phone number if provided
    if (
      userDetails.phone_number &&
      !ukPhoneRegex.test(userDetails.phone_number)
    ) {
      message.error(
        "Please enter a valid UK phone number (e.g., +441234567890 or 07123456789)"
      );
      setUpdateLoading(false);
      return;
    }

    const selectedKeywords = emailPreferance.filter((k) => k.is_selected);
    const newUnselectedKeywords = emailPreferance.map((k) => ({
      ...k,
      id: k.id == null ? null : k.id,
      _uiKey: undefined,
    }));
    const allKeywords = [...selectedKeywords, ...newUnselectedKeywords];
    // console.log("newUnselectedKeywords", newUnselectedKeywords);
    // return
    const payload = {};

    if (imageUrl) payload.profile_image_path = imageUrl;
    if (userDetails.name) payload.name = userDetails.name;
    if (userDetails.nickname) payload.nickname = userDetails.nickname;
    if (userDetails.phone_number)
      payload.phone_number = userDetails.phone_number;
    if (userDetails.email) payload.email = userDetails.email;
    if (password) payload.new_password = password;
    if (confirmPassword) payload.new_password_confirmation = confirmPassword;
    if (selectedKeyword) payload.email_preferences = newUnselectedKeywords;
    if (deletedKeywords) payload.deleted_keywords = deletedKeywords;
    if (removeProfile) payload.remove_profile_image = 1;

    try {
      const response = await fetch(`${URL}/v1/update-profile`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.code == 200) {
        message.success("Profile Updated Successfully");
        setUpdateLoading(false);
        setIsUploading(false);
        setEmailselect(false);
        setShowPasswordFields(false);
        getuserData();
        fetchProfile();
      } else if (data.errors?.email_preferences) {
        setUpdateLoading(false);
        message.error(data.errors.email_preferences[0]);
      } else if (data.errors?.new_password) {
        setUpdateLoading(false);
        message.error(data.errors.new_password[0]);
      } else if (data.message) {
        setUpdateLoading(false);
        message.error(data.message);
      } else {
        setUpdateLoading(false);
        message.error("Failed to update profile. Please try again.");
      }
    } catch (error) {
      setUpdateLoading(false);
      message.error("Failed to update profile. Please try again.");
    }
  };

  useEffect(() => {
    getuserData();
    getemailKeyword();
    handlemetaData();
    // getsubscription();
    fetchSubscriptions();
  }, []);

  const handleInputChange = (e) => {
    setNewTask(e.target.value);
  };

  const handleSubmit = () => {
    if (newTask.trim() !== "") {
      const taskTitle = newTask.trim();

      // Check if the keyword already exists
      const isDuplicate = emailPreferance.some(
        (keyword) => keyword.title.toLowerCase() === taskTitle.toLowerCase()
      );

      if (isDuplicate) {
        message.warning("This keyword already exists!");
        return;
      }

      // Remove from deletedKeywords if needed
      setDeletedKeywords((prevDeleted) =>
        prevDeleted.filter(
          (deletedId) => false // Always remove, or add logic if you want to restore
        )
      );

      // Add the new keyword with a unique UI key
      const newKeyword = {
        id: null,
        title: taskTitle,
        is_selected: 0,
        is_added_by_admin: 0,
        onboarding_step_keyword: 0,
        _uiKey: Date.now() + Math.random(), // Unique for UI
      };

      setEmailPreferance((prev) => [...prev, newKeyword]);
      setNewTask("");
      setVisible(false);
    }
  };
  console.log(emailPreferance, "emailPreferance");

  const popoverContent = (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <Input
        placeholder="Enter keyword name"
        value={newTask}
        onChange={handleInputChange}
      />
      <Button type="primary" onClick={handleSubmit}>
        Submit
      </Button>
    </div>
  );

  const handleSelectRole = (roleId) => {
    setSelectedRole(roleId);
  };

  const handleCreateSubscribe = async () => {
    const payload = {
      user_category_id: selectedRole,
    };

    try {
      const response = await fetch(`${URL}/v1/update-subscription`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.code == 200) {
        message.success("Subscription Updated Successfully");
        getsubscription();
        setSelectCard(false);
      }
    } catch {}
  };

  const handleSubscribePlan = () => {
    const plan = subscriptionData.find(
      (p) => p.subscription_id === subscriptionId
    );
    if (!plan) return message.warning("Please select a plan");
    setSelectedPlan(plan);
    setShowPaymentForm(true); // show the card form
  };
  const handleDelete = (keyword) => {
    if (
      Number(keyword.is_added_by_admin) === 0 &&
      Number(keyword.onboarding_step_keyword) === 0
    ) {
      // Remove from main emailPreference list
      setEmailPreferance((prev) =>
        prev.filter(
          (k) =>
            !(
              Number(k.is_added_by_admin) === 0 &&
              (k.id ? k.id === keyword.id : k._uiKey === keyword._uiKey)
            )
        )
      );

      // If needed, track deleted keywords separately
      if (keyword.id) {
        setDeletedKeywords((prev) => [...prev, keyword.id]);
      }
    } else {
      message.warning("Admin-added keywords cannot be deleted.");
    }
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value.trim();
    setPassword(value);

    if (value && !passwordPattern.test(value)) {
      setPasswordError(
        "Password must be at least 8 characters long and include at least 1 uppercase letter, 1 number, and 1 special character."
      );
    } else {
      setPasswordError("");
    }
  };

  const roleImages = {
    4: family,
    5: schoolrepresentative,
    6: familymember,
    7: coparentprofile,
  };
  // const props = {
  //   name: 'file',
  //   action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
  //   headers: {
  //     authorization: 'authorization-text',
  //   },
  //   onChange(info) {
  //     if (info.file.status !== 'uploading') {
  //       console.log(info.file, info.fileList);
  //     }
  //     if (info.file.status === 'done') {
  //       message.success(`${info.file.name} file uploaded successfully`);
  //     } else if (info.file.status === 'error') {
  //       message.error(`${info.file.name} file upload failed.`);
  //     }
  //   },
  // };

  const GoogleAuthSignup = async () => {
    // try {
    //   const response = await fetch(`${URL}/v1/auth/google/link`, {
    //     method: "GET",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });

    //   const data = await response.json();
    //   console.log("data::::::",data)
    //   if (data.code == 200) {
    //    } else {
    //     console.error("Invalid response from server:", data); // Log detailed error
    //     // message.error("Failed to load profile data."); // User-friendly error message
    //   }
    //   console.log("response>>>>>", data);
    // } catch (error) {}

    try {
      window.location.href = `${URL}/v1/auth/google/link?source=view_profile`;
    } catch (error) {
      console.log("error", error);
    }
  };

  // function to understand User-Current Plan
  // function getSubscriptionIdFromFeatures(userFeatures, allSubscriptions) {
  //   const userFeatureIds = userFeatures.map(f => f.id).sort((a, b) => a - b);

  //   for (const sub of allSubscriptions) {
  //     const subFeatureIds = sub.services.map(s => s.id).sort((a, b) => a - b);
  //     if (JSON.stringify(userFeatureIds) === JSON.stringify(subFeatureIds)) {
  //       return sub.subscription_id;
  //     }
  //   }

  //   return null;
  // }

  // const subscriptionId = getSubscriptionIdFromFeatures(userFeatures, subscriptionData);

  // console.log("subscriptionId", subscriptionId)

  const CustomSkeletonCard = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 20,
          width: 250,
          border: "1px solid #f0f0f0",
          borderRadius: 8,
        }}
      >
        <Skeleton.Avatar active shape="circle" size={64} />
        <div style={{ width: "100%", marginTop: 16 }}>
          <Skeleton.Input
            active
            style={{
              width: "80%",
              margin: "0 auto 8px auto",
              display: "block",
            }}
            size="small"
          />
          <Skeleton.Input
            active
            style={{ width: "60%", margin: "0 auto", display: "block" }}
            size="small"
          />
        </div>
      </div>
    );
  };

  const userOnboardedKeywords = emailPreferance.filter(
    (preference) => preference.onboarding_step_keyword === 1
  ); // Only show selected preferences

  const customKeywords = emailPreferance.filter(
    (preference) =>
      Number(preference.onboarding_step_keyword) === 0 &&
      Number(preference.is_added_by_admin) === 0
  ); // Only show selected preferences

  return (
    <div className="profile-page-parent">
      <div
        style={{ fontSize: "22px", fontWeight: "600" }}
      >
        Edit profile{" "}
      </div>

      <div className="my-profile-page">
        <div className="my-profile-coloumn-one">
          <Row gutter={[16, 16]}>
            <Col span={22}>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Profile image
              </span>
              <div className="profile-image">
                <div style={{ marginTop: "10px" }}>
                  <Image
                    src={imageUrl || profileImage || Profile}
                    style={{
                      borderRadius: "100%",
                      height: "110px",
                      width: "110px",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div style={{}}>
                  {isUploading ? (
                    <div className="upload-section">
                      <Upload
                        className="custom-upload"
                        showUploadList={true}
                        maxCount={1}
                        beforeUpload={beforeUpload}
                      >
                        <div className="upload-box">
                          <img src={uploadicon} width={31} />
                          <div style={{ fontSize: "12px", color: "#9254de" }}>
                            Click to upload{" "}
                            <span className="upload-info">
                              SVG, PNG, JPG, GIF (max 800 × 400px)
                            </span>
                          </div>
                        </div>
                      </Upload>
                      {(profileImage || imageUrl) && (
                        <Button
                          size="small"
                          style={{ marginTop: 8 }}
                          onClick={async () => {
                            setRemoveProfile(true);
                            setProfileImage("");
                            setImageUrl("");
                            setIsUploading(false);
                          }}
                        >
                          Delete Image
                        </Button>
                      )}
                    </div>
                  ) : (
                    <span
                      className="change-pic-text"
                      onClick={() => setIsUploading(true)}
                    >
                      Change Picture
                    </span>
                  )}
                </div>
              </div>
            </Col>
            <Col className="update-profile-fields" span={22}>
              <div className="custom-floating-wrapper">
                <input
                  type="text"
                  value={userDetails.name}
                  onChange={(e) => handleInputChangeform(e, "name")}
                  disabled={!isEditable.name}
                  placeholder=" " // Required for floating label
                  className="custom-floating-input"
                  ref={(el) => (inputRefs.current.name = el)}
                />
                <label className={inputValue ? "custom-floating-text" : ""}>
                  Full name{" "}
                </label>
                <span
                  className="custom-suffix-icon"
                  onClick={() => toggleEdit("name")}
                >
                  <EditOutlined />
                </span>
              </div>
              <div className="custom-floating-wrapper">
                <input
                  type="text"
                  value={userDetails.nickname}
                  onChange={(e) => handleInputChangeform(e, "nickname")}
                  disabled={!isEditable.nickname}
                  placeholder=" " // Required for floating label
                  className="custom-floating-input"
                  ref={(el) => (inputRefs.current.nickname = el)}
                />
                <label className={inputValue ? "custom-floating-text" : ""}>
                  Nick name{" "}
                </label>
                <span
                  className="custom-suffix-icon"
                  onClick={() => toggleEdit("nickname")}
                >
                  <EditOutlined />
                </span>
              </div>

              <div className="custom-floating-wrapper">
                <input
                  type="text"
                  value={userDetails.phone_number}
                  onChange={(e) => handleInputChangeform(e, "phone_number")}
                  disabled={!isEditable.phone_number}
                  placeholder=" " // Required for floating label
                  className="custom-floating-input"
                  ref={(el) => (inputRefs.current.phone_number = el)}
                  inputMode="numeric" // Helps on mobile devices
                  onBlur={() => handleInputBlur("phone_number")} // ✅ Hide error on blur
                />
                <label className={inputValue ? "custom-floating-text" : ""}>
                  Phone Number{" "}
                </label>
                <span
                  className="custom-suffix-icon"
                  onClick={() => toggleEdit("phone_number")}
                >
                  <EditOutlined />
                </span>
              </div>
              {phonenumbererror.phone_number && (
                <p className="error-text">{phonenumbererror.phone_number}</p>
              )}

              <div className="custom-floating-wrapper">
                <input
                  type="text"
                  value={userDetails.email}
                  placeholder=" " // Required for floating label
                  className="custom-floating-input"
                  disabled
                />
                <label className={inputValue ? "custom-floating-text" : ""}>
                  Email{" "}
                </label>
                <span className="custom-suffix-icon">
                  {/* <EditOutlined /> */}
                </span>
              </div>
              {!showPasswordFields && (
                <div className="custom-floating-wrapper">
                  <input
                    type="text"
                    value="***********"
                    placeholder=" "
                    className="custom-floating-input"
                    readOnly
                  />
                  <label className="custom-floating-text">Password</label>
                  <span
                    className="custom-suffix-icon"
                    onClick={() => setShowPasswordFields(true)}
                  >
                    <EditOutlined />
                  </span>
                </div>
              )}
              {showPasswordFields && (
                <>
                  <div className="custom-floating-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder=" "
                      className="custom-floating-input"
                      value={password}
                      onChange={handleNewPasswordChange}
                    />
                    <label className="custom-floating-text">New Password</label>
                    <span
                      className="custom-suffix-icon"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? (
                        <EyeOutlined />
                      ) : (
                        <EyeInvisibleOutlined />
                      )}
                    </span>
                  </div>
                  {passwordError && (
                    <p className="error-text">{passwordError}</p>
                  )}

                  <div className="custom-floating-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder=" "
                      className="custom-floating-input"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                    />
                    <label className="custom-floating-text">
                      Confirm Password
                    </label>
                    <span
                      className="custom-suffix-icon"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? (
                        <EyeOutlined />
                      ) : (
                        <EyeInvisibleOutlined />
                      )}
                    </span>
                  </div>
                  {confirmError && <p className="error-text">{confirmError}</p>}
                </>
              )}
            </Col>
          </Row>
        </div>
        <div className="my-profile-coloumn-two">
          <SubscriptionManager
            stripePromise={stripePromise}
            subscriptionData={subscriptionData}
            fetchSubscriptions={fetchSubscriptions}
            activePlanLoading={activePlanLoading}
            setEmailselect={setEmailselect}
            currentStepC2={currentStepC2}
            setCurrentStepC2={setCurrentStepC2}
          />
          <Row>
            {emailFlag ? (
              <>
                <Col span={22}>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "20px",
                    }}
                  >
                    Email is Registered
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#767A83",
                      marginBottom: "20px",
                      marginTop: "20px",
                    }}
                  >
                    Your email is
                  </div>
                  <div>
                    <Input
                      className="email-input"
                      value={emailFlag}
                      addonAfter={<img src={googleicon} width={20} />}
                      size="large"
                      disabled
                      style={{ color: "black" }}
                    />
                  </div>
                </Col>
              </>
            ) : (
              <Col span={22}>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    // paddingLeft: "15px",
                  }}
                >
                  Register your email
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#767A83",
                    marginBottom: "20px",
                    marginTop: "5px",
                    // paddingLeft: "15px",
                  }}
                  className="google-profile"
                >
                  Please log in to capture your email events{" "}
                </div>

                <Button
                  className="social-button-google"
                  style={{ width: "100%", maxWidth: "590px", height: "48px" }}
                  onClick={GoogleAuthSignup}
                >
                  <img src={googleicon} width={16} /> Google
                </Button>
                {/* <Button
                  className="social-button-google"
                  style={{ width: "100%", maxWidth: "590px", height: "48px" }}
                >
                  <img src={applelogo} width={16} /> Apple
                </Button> */}
              </Col>
            )}
            {currentStepC2 === 1 && (
              <>
                {!emailselect ? (
                  <Col span={22}>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        display: "flex",
                        justifyContent: "space-between",
                        // paddingLeft: "15px",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      Your Email Search Criteria
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#9254de",
                          cursor: "pointer",
                        }}
                        onClick={handleEmailsearch}
                      >
                        Change
                      </span>
                    </div>
                    <div>
                      {emailPreferance
                        .filter((preference) => preference.is_selected === 1) // Only show selected preferences
                        .map((preference, index) => (
                          <Tag key={index} className="tag">
                            {preference.title}
                          </Tag>
                        ))}
                      {/* <div className="tag">School Closures/Delays</div>
  <div className="tag">Homework/Assignments</div> */}
                    </div>
                  </Col>
                ) : (
                  <Col>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        // paddingLeft: "15px",
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "15px",
                        marginBottom: "0px",
                      }}
                    >
                      Your Email Search Criteria
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#9254de",
                          cursor: "pointer",
                        }}
                        onClick={() => setEmailselect(false)}
                      >
                        Cancel
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#767A83",
                        marginTop: "0px",
                        marginBottom: "10px",
                        fontWeight: "300",
                      }}
                      onClick={handleEmailsearch}
                    >
                      Select the task categories, list templates, and widgets
                      that are perfect for your needs
                    </div>

                    <div style={{ width: "600px" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        {emailPreferance
                          .filter((key) => Number(key.is_added_by_admin) === 1)
                          .map((keyword) => (
                            <Tag
                              key={
                                keyword.id !== null
                                  ? keyword.id
                                  : keyword._uiKey
                              }
                              closable={keyword.is_added_by_admin == 0}
                              onClose={() => handleDelete(keyword)}
                              className={`tag ${
                                keyword.is_selected ? "selected-tag" : ""
                              }`}
                              onClick={() => handleSelect(keyword)}
                              style={{
                                borderRadius: "5px",
                                padding: "8px 16px",
                                fontSize: "14px",
                                cursor: "pointer",
                                background: keyword.is_selected
                                  ? "#FEF1FE"
                                  : "white",
                                color: keyword.is_selected
                                  ? "#9A4FE0"
                                  : "#1D2433",
                                border: keyword.is_selected
                                  ? "1px solid #9A4FE0"
                                  : "1px solid rgb(231, 230, 230)",
                              }}
                            >
                              {keyword.title}
                            </Tag>
                          ))}
                      </div>

                      <div className="mt-4">
                        <p
                          style={{
                            fontWeight: 300,
                            color: "rgb(118, 122, 131)",
                            fontSize: 12,
                          }}
                          className="mt-3"
                        >
                          You can only select any 3 keywords between custom and
                          onboarding keywords
                        </p>
                        <h3
                          style={{ fontSize: 16, fontWeight: 600 }}
                          className="mb-1"
                        >
                          Keywords selected during registration
                        </h3>
                        {userOnboardedKeywords.map((keyword) => (
                          <Tag
                            key={
                              keyword.id !== null ? keyword.id : keyword._uiKey
                            }
                            closable={keyword.onboarding_step_keyword == 0}
                            onClose={() => handleDelete(keyword)}
                            className={`tag ${
                              keyword.is_selected ? "selected-tag" : ""
                            }`}
                            onClick={() => handleSelect(keyword)}
                            style={{
                              borderRadius: "5px",
                              padding: "8px 16px",
                              fontSize: "14px",
                              cursor: "pointer",
                              background: keyword.is_selected
                                ? "#FEF1FE"
                                : "white",
                              color: keyword.is_selected
                                ? "#9A4FE0"
                                : "#1D2433",
                              border: keyword.is_selected
                                ? "1px solid #9A4FE0"
                                : "1px solid rgb(231, 230, 230)",
                            }}
                          >
                            {keyword.title}
                          </Tag>
                        ))}
                      </div>

                      <div className="mt-4">
                        <h3
                          style={{ fontSize: 16, fontWeight: 600 }}
                          className="mb-1"
                        >
                          Custom Keywords
                        </h3>
                        {customKeywords.map((keyword) => (
                          <Tag
                            key={
                              keyword.id !== null ? keyword.id : keyword._uiKey
                            }
                            closable={
                              Number(keyword.is_added_by_admin) == 0 &&
                              Number(keyword.onboarding_step_keyword) === 0
                            }
                            onClose={(e) => {
                              e.preventDefault();
                              handleDelete(keyword);
                            }}
                            className={`tag ${
                              keyword.is_selected ? "selected-tag" : ""
                            }`}
                            onClick={() => handleSelect(keyword)}
                            style={{
                              borderRadius: "5px",
                              padding: "8px 16px",
                              fontSize: "14px",
                              cursor: "pointer",
                              background: keyword.is_selected
                                ? "#FEF1FE"
                                : "white",
                              color: keyword.is_selected
                                ? "#9A4FE0"
                                : "#1D2433",
                              border: keyword.is_selected
                                ? "1px solid #9A4FE0"
                                : "1px solid rgb(231, 230, 230)",
                            }}
                          >
                            {keyword.title}
                          </Tag>
                        ))}
                      </div>
                      <Popover
                        content={popoverContent}
                        title="Create Keyword"
                        trigger="click"
                        open={visible}
                        onOpenChange={(open) => setVisible(open)}
                        className="mt-2"
                      >
                        <Button type="primary">Add keywords</Button>
                      </Popover>
                    </div>
                  </Col>
                )}
              </>
            )}
          </Row>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Button
          onClick={handleUpdate}
          loading={updateLodaing}
          disabled={updateLodaing}
          style={{
            width: "379px",
            height: "48px",
            color: "white",
            backgroundColor: "#9747FF",
          }}
        >
          Update
        </Button>
      </div>
    </div>
  );
};

const SubscriptionManager = ({
  subscriptionData,
  fetchSubscriptions,
  activePlanLoading,
  stripePromise,
  setEmailselect,
  currentStepC2,
  setCurrentStepC2,
}) => {
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isModalClosing, setIsModalClosing] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const activePlan = subscriptionData?.find((p) => p.is_purchased);
    if (activePlan) {
      setSubscriptionId(activePlan.subscription_id);
      setSelectedPlan(activePlan);
    }
  }, [subscriptionData]);

  const handleClickChange = () => {
    setEmailselect(false);
    setCurrentStepC2(2);
  };

  const handleSubscribePlan = () => {
    const plan = subscriptionData.find(
      (p) => p.subscription_id === subscriptionId
    );
    if (!plan) {
      message.error("Please select a subscription plan.");
      return;
    }
    if (plan.is_purchased) {
      message.error("You are already subscribed to this plan.");
      return;
    }
    setSelectedPlan(plan);
    setCurrentStepC2(3);
  };

  const handleCancelClick = (e) => {
    e.stopPropagation();
    setShowCancelModal(true);
  };

  const handleCancelConfirm = async () => {
    try {
      setCancelling(true);
      const response = await fetch(`${URL}/v1/cancel-subscription`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      const data = await response.json();

      if (data.code === 200) {
        message.success("Subscription cancelled successfully");
        fetchSubscriptions();
        setCurrentStepC2(2);
      } else {
        message.error(data.message || "Failed to cancel subscription");
      }
    } catch (error) {
      message.error("An error occurred while cancelling subscription");
    } finally {
      setCancelling(false);
      handleModalClose();
    }
  };

  const handleModalClose = () => {
    setIsModalClosing(true);
    setTimeout(() => {
      setShowCancelModal(false);
      setIsModalClosing(false);
    }, 300);
  };

  const getPlanIcon = (title) => {
    if (title.includes("Lifestyle Core")) return emailAssistant;
    if (title.includes("Family")) return familyCalendar;
    if (title.includes("Co-Parent")) return coParentCalendar;
    return null;
  };

  return (
    <>
      {currentStepC2 === 1 && (
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div
              style={{
                fontSize: "16px",
                fontWeight: "600",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}
            >
              Subscription Status
              <span
                style={{
                  fontSize: "12px",
                  color: "#9254de",
                  cursor: "pointer",
                }}
                onClick={handleClickChange}
              >
                Change
              </span>
            </div>
            <Col span={24}>
              {activePlanLoading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <OptionCard selected={false}>
                    <div className="image-container">
                      <Skeleton.Avatar active shape="circle" size={48} />
                    </div>
                    <h3>
                      <Skeleton.Input
                        active
                        size="small"
                        style={{ width: "60%" }}
                      />
                    </h3>
                    <p>
                      <Skeleton.Input
                        active
                        size="small"
                        style={{ width: "80%" }}
                      />
                    </p>
                  </OptionCard>
                </div>
              ) : subscriptionData?.filter((option) => option.is_purchased)
                  .length > 0 ? (
                subscriptionData
                  ?.filter((option) => option.is_purchased)
                  .map((option) => (
                    <OptionCard
                      key={option.subscription_id}
                      selected={subscriptionId === option.subscription_id}
                      onClick={() => setSubscriptionId(option.subscription_id)}
                    >
                      <div className="image-container">
                        {option.title.includes("Lifestyle Core") ? (
                          <img src={emailAssistant} alt={option.title} />
                        ) : option.title.includes("Family") ? (
                          <img src={familyCalendar} alt={option.title} />
                        ) : option.title.includes("Co-Parent") ? (
                          <img src={coParentCalendar} alt={option.title} />
                        ) : (
                          <div className="image-placeholder" />
                        )}
                      </div>
                      <h3>{option.title}</h3>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        {/* <PriceDisplay amount={option.price} /> */}
                        <PriceDisplay
                          price={option.price}
                          special_price={option.special_price}
                          billingCycle={
                            option.billing_cycle.charAt(0).toUpperCase() +
                            option.billing_cycle.slice(1)
                          }
                        />
                      </div>
                      <p>{option.short_description}</p>

                      <div className="current-badge">Current Plan</div>

                      {option.is_active === 1 && (
                        <Button
                          type="primary"
                          danger
                          style={{ marginTop: "16px", width: "100%" }}
                          onClick={handleCancelClick}
                          loading={cancelling}
                        >
                          Cancel Subscription
                        </Button>
                      )}
                    </OptionCard>
                  ))
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    background: "#f9f9f9",
                    borderRadius: "16px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  }}
                >
                  <h3 style={{ marginBottom: "16px", color: "#666" }}>
                    No Active Subscription
                  </h3>
                  <p style={{ marginBottom: "24px", color: "#888" }}>
                    You don't have any active subscription plans.
                  </p>
                  <Button type="primary" onClick={handleClickChange}>
                    Subscribe Now
                  </Button>
                </div>
              )}
            </Col>
          </Col>
        </Row>
      )}

      {currentStepC2 === 2 && (
        <>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p>Select a Plan</p>
            <Button onClick={() => navigate("/pricing")}>
              Explore all plans
            </Button>
          </div>
          <Row className="plans-cards-grid" gutter={[10, 10]}>
            <Grid>
              {subscriptionData.map((option) => {
                const isCurrentPlan = option.is_purchased; // Use the existing property from your data
                return (
                  <OptionCard
                    key={option.subscription_id}
                    selected={subscriptionId === option.subscription_id}
                    onClick={
                      !isCurrentPlan
                        ? () => setSubscriptionId(option.subscription_id)
                        : null
                    }
                    style={
                      isCurrentPlan
                        ? { opacity: 0.6, cursor: "not-allowed" }
                        : {}
                    }
                  >
                    <div className="image-container">
                      {option.title.includes("Lifestyle Core") ? (
                        <img src={emailAssistant} alt={option.title} />
                      ) : option.title.includes("Family") ? (
                        <img src={familyCalendar} alt={option.title} />
                      ) : option.title.includes("Co-Parent") ? (
                        <img src={coParentCalendar} alt={option.title} />
                      ) : (
                        <div className="image-placeholder" />
                      )}
                    </div>
                    <h3>{option.title}</h3>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {/* <PriceDisplay amount={option.price} /> */}
                      <PriceDisplay
                        price={option.price}
                        special_price={option.special_price}
                        billingCycle={option.billing_cycle}
                      />
                    </div>
                    <p>{option.short_description}</p>

                    {isCurrentPlan ? (
                      <div className="current-badge">Current Plan</div>
                    ) : (
                      <Radio
                        className="radio"
                        checked={subscriptionId === option.subscription_id}
                        disabled={isCurrentPlan}
                      />
                    )}
                  </OptionCard>
                );
              })}
            </Grid>
            <Row
              style={{
                marginTop: "6px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Col>
                <Button onClick={() => setCurrentStepC2(1)}>Back</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleSubscribePlan}
                  // disabled={selectedPlan?.is_purchased}
                >
                  Subscribe Now
                </Button>
              </Col>
            </Row>
          </Row>
        </>
      )}

      {currentStepC2 === 3 && (
        <Elements stripe={stripePromise}>
          <PaymentForm
            subscriptionData={subscriptionData}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
            onBack={() => setCurrentStepC2(2)}
            onSubscribed={() => {
              // message.success("Subscribed successfully!");
              fetchSubscriptions();
              setCurrentStepC2(4);
            }}
            fetchSubscriptions={fetchSubscriptions}
          />
        </Elements>
      )}

      {currentStepC2 === 4 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px 20px",
            background: "#f9f9f9",
            borderRadius: "16px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: 600,
              marginBottom: "16px",
              color: "#52c41a",
            }}
          >
            🎉 Thank you for subscribing!
          </h2>
          <p style={{ fontSize: "16px", marginBottom: "32px", color: "#333" }}>
            You are now on the <strong>{selectedPlan?.title}</strong> plan.
          </p>
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: "8px", padding: "0 24px" }}
            onClick={() => setCurrentStepC2(1)}
          >
            Back to Current Plan
          </Button>
        </div>
      )}

      <CancelSubscriptionModal
        isOpen={showCancelModal}
        onConfirm={handleCancelConfirm}
        onClose={handleModalClose}
        planName={selectedPlan?.title || "Current Plan"}
        planIcon={selectedPlan ? getPlanIcon(selectedPlan.title) : null}
        isClosing={isModalClosing}
      />
    </>
  );
};

export default MyProfile;
